import { render, staticRenderFns } from "./CInvoicePaymentDetails.vue?vue&type=template&id=0b496561&scoped=true"
import script from "./CInvoicePaymentDetails.vue?vue&type=script&lang=ts"
export * from "./CInvoicePaymentDetails.vue?vue&type=script&lang=ts"
import style0 from "./CInvoicePaymentDetails.vue?vue&type=style&index=0&id=0b496561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b496561",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
